import React, { useRef } from 'react';
import { Modal, Pressable, Text, View } from 'react-native';
import { WebView } from 'react-native-webview';
import { BlurView } from 'expo-blur';
import { useColorScheme } from 'nativewind';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useTranslation } from 'react-i18next';
import { Icon } from '../index';
import svgIcons from '../../assets';

interface Props {
  showModal: boolean;
  closeModal: () => void;
  uri: string;
}

const WebViewModal: React.FC<Props> = ({ showModal, closeModal, uri }) => {
  const { colorScheme } = useColorScheme();
  const insets = useSafeAreaInsets();
  const { t } = useTranslation();
  const webViewRef = useRef(null);

  return (
    <Modal
      animationType="slide"
      presentationStyle="overFullScreen"
      visible={showModal}
      transparent={false}
    >
      <View className="flex-1 bg-neutral-50 dark:bg-neutral-950">
        <BlurView
          className="flex-row items-center"
          style={{
            paddingTop: insets.top + 10,
            paddingBottom: 10,
            paddingHorizontal: 32,
            backgroundColor:
              colorScheme === 'dark' ? 'rgba(16,16,16,0.9)' : 'rgba(246,246,246,0.9)',
          }}
          intensity={30}
          tint={colorScheme}
        >
          <Pressable onPress={closeModal} hitSlop={8} className="flex-row items-center">
            <Icon
              icon={svgIcons.arrowLeftIcon}
              mobileSize={{ width: 24, height: 24 }}
              webSize={{ width: 24, height: 24 }}
            />
            <Text className="text-neutral-950 dark:text-neutral-50 font-[sans-600] text-notificationMessage ml-2">
              {t('helpdesk:back_to_ulp')}
            </Text>
          </Pressable>
        </BlurView>

        <WebView ref={webViewRef} source={{ uri }} javaScriptEnabled={true} />
      </View>
    </Modal>
  );
};

export default WebViewModal;
